// extracted by mini-css-extract-plugin
export default {"wrapper":"CardHandSmall_wrapper__l8mpU","empty":"CardHandSmall_empty__p7Liv"};